import { call, put, select, takeEvery } from 'redux-saga/effects';

import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../../../actions/static-catalogs/insurance-agents';
import * as authSelectors from '../../../reducers/auth';
import * as schemas from '../../../schemas/insurance-agents';
import * as types from '../../../types/static-catalogs/insurance-agents';
import API_BASE_URL from '../../settings/apibaseurl';
/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchInsuranceAgentsList(action) {
  const country = action.payload;
  try {
    const isAuth = yield select(authSelectors.isAuthenticated);
    if (isAuth && (country || country === 0)) {
      const token = yield select(authSelectors.getAuthToken);
      const response = yield call(fetch, `${API_BASE_URL}/insuranceAgent/get`, {
        method: 'POST',
        body: JSON.stringify({ country }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      const jsonResult = yield response.json();
      if (response.status <= 300 && jsonResult.success) {
        const resultData = jsonResult.data.map((result) => camelcaseKeys(result));
        const {
          entities: { insuranceAgents },
          result //order
        } = normalize(resultData, schemas.insuranceAgents); //normalize data to byId and order
        yield put(actions.completeFetchingInsuranceAgents(insuranceAgents, result));
      } else {
        const error = {
          errorMessage: jsonResult.message,
          errorNumber: jsonResult.number
        };
        // alerts.showErrorAlertFailChanges({ error });
        yield put(actions.failFetchingInsuranceAgents(error));
      }
    }
  } catch (err) {
    const error = {
      errorMessage: err.toString(),
      errorNumber: -1
    };
    // alerts.showErrorAlertFailChanges({ error });
    yield put(actions.failFetchingInsuranceAgents(error));
  }
}

export function* watchFetchInsuranceAgentsList() {
  yield takeEvery(types.INSURANCE_AGENTS_FETCH_STARTED, fetchInsuranceAgentsList);
}
